import { useSearchParams } from 'react-router-dom'

import i18n from './i18n'
import css from './index.module.css'

import { Config } from '#/global/helper/Config'

export const Title = () => {
    const title = i18n[Config.getLang()].title

    const [searchParameters] = useSearchParams()
    const query = searchParameters.get('query')

    return (
        <h1 className={css.title} data-name="r-a-search r-title">
            {title}
            <span className={css.green}>{query}</span>
        </h1>
    )
}
